import { IMicrofrontendsAPI } from '../../../shared/types/microfrontends/types';
import { getSearchStringMicrofrontendAPI } from '../getSearchStringMicrofrontendApi/getSearchStringMicrofrontendApi';

export function createMicrofrontendsAPI(): IMicrofrontendsAPI {
  return {
    getSearchStringMicrofrontendAPI: () => getSearchStringMicrofrontendAPI(),
  };
}
